import Header from "../organisms/Header";
import Footer from "../organisms/Footer";
import { useLocation } from 'react-router-dom'
function Layout(props) {
  const location = useLocation();
  console.log(location.pathname);
  return (
    <div>
      <Header headerTitle={props.headerTitle}/>
     
      <div className={props.main === "main" ? "main p-5" : "p-5"}>
        <img
          src="https://res.cloudinary.com/standard-insurance/image/upload/v1623759087/sici/standard-insurance-logo_kjyvao.png"
          width="170"
          height="50"
          alt="logo"
        />
      </div>
      <main className={props.main === "main" ? "main p-5" : "p-5"}>{props.children}</main> 
      <Footer buttonType={props.buttonType} link={props.link} />
    </div>
  );
}

export default Layout;
